import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  private invoiceListSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public invoiceList$: Observable<any[]> = this.invoiceListSubject.asObservable();
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string): void {
    this.snackBar.dismiss(); // Close existing snackbars
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000,
      panelClass: ['success-snackbar'],
    });
  }

  showError(message: string): void {
    this.snackBar.dismiss(); // Close existing snackbars
    const snackBarRef = this.snackBar.open(message, 'Dismiss', {
      duration: 3000, // No auto-close
      panelClass: ['error-snackbar'],
    });

    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss(); // Close when action is triggered
    });
  }


  setInvoiceList(invoices: any[]): void {
    this.invoiceListSubject.next(invoices);
  }

  // Optional: Get the current invoice list value
  getInvoiceList(): any[] {
    return this.invoiceListSubject.getValue();
  }
}
